import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '@/i18n/LanguageContext';
import { useAuth } from '@/auth/AuthContext';
import PageDetailsAccordion from '@/components/PageDetailsAccordion';
import { EditorialPage, EditorialSection, EditorialCards, EditorialLinks } from '@/components/Editorial';

const textLink = 'text-[#557448] underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4';

export default function ForEntities() {
  const { t } = useLang();
  const { user, isChecking } = useAuth();
  const present = { to: '/list-your-farm', label: t('entitiesPage.present') };
  return <EditorialPage testId="for-entities-page" title={t('entitiesPage.title')} intro={t('entitiesPage.intro')}>
    <EditorialLinks links={[present, { to: '/atlas', label: t('profilePathCommon.atlas') }]} />
    <p className="mt-3 text-sm text-[#6E6258]">{t('profilePathCommon.accountNote')}</p>
    <EditorialSection title={t('entitiesPage.cardsTitle')} symbol="choices">
      <EditorialCards symbols={['public', 'parks', 'care', 'community', 'document']} items={t('entitiesPage.cards')} />
    </EditorialSection>
    <EditorialSection title={t('entitiesPage.organizationTitle')} symbol="institution">
      <p className="text-[#4A443D] leading-relaxed">{t('entitiesPage.organization')}</p>
    </EditorialSection>
    <EditorialSection title={t('entitiesPage.opportunitiesTitle')} symbol="handshake">
      <p className="mb-5 text-[#4A443D] leading-relaxed">{t('entitiesPage.opportunities')}</p>
      <EditorialCards symbols={['contribution', 'document', 'community', 'heart']} items={t('entitiesPage.examples')} />
      <p className="mt-3 text-sm text-[#6E6258]">{t('profilePathCommon.activityNote')}</p>
      <p className="mt-4 text-sm"><Link className={textLink} to="/how-it-works">{t('profilePathCommon.formulas')}</Link></p>
    </EditorialSection>
    <EditorialSection title={t('entitiesPage.detailsTitle')}>
      <PageDetailsAccordion panels={t('entitiesPage.details').map((panel, index) => ({
        id: ['entity-category-profile', 'entity-roles-responsibility', 'entity-project-land', 'entity-activity-requirements'][index], title: panel.title,
        children: <>{panel.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}</>,
      }))} />
    </EditorialSection>
    <EditorialSection title={t('profilePathCommon.plansTitle')} symbol="choices">
      <p className="text-[#4A443D] leading-relaxed">{t('profilePathCommon.plansSummary')}</p>
      <p className="mt-3 text-[#3E5733]" data-testid="entities-public-exception">{t('plansPage.publicException')}</p>
      <div className="flex flex-wrap gap-x-5 gap-y-2 mt-4 text-sm">
        <Link className={textLink} to="/plans">{t('profilePathCommon.comparePlans')}</Link>
        <Link className={textLink} to="/plans#pro-payments-fees">{t('profilePathCommon.fees')}</Link>
      </div>
    </EditorialSection>
    <aside className="mt-8 rounded-md border border-[#E2DACB] bg-[#EAF0E6] p-4 text-sm text-[#4A443D]" data-testid="profile-representation-note">{t('profilePathCommon.representation')}</aside>
    <EditorialSection title={t('profilePathCommon.startTitle')}>
      <EditorialLinks links={[present, { to: '/projects', label: t('profilePathCommon.projects') }]} />
      <div className="flex flex-wrap gap-x-5 gap-y-2 mt-4 text-sm">
        <Link className={textLink} to="/faq">{t('profilePathCommon.faq')}</Link>
        {user && !isChecking && <Link className={textLink} to="/dashboard">{t('profilePathCommon.manageProfiles')}</Link>}
      </div>
    </EditorialSection>
  </EditorialPage>;
}
